import { render, staticRenderFns } from "./CategoryManager.vue?vue&type=template&id=0c1b1401&scoped=true"
import script from "./CategoryManager.vue?vue&type=script&lang=js"
export * from "./CategoryManager.vue?vue&type=script&lang=js"
import style0 from "./CategoryManager.vue?vue&type=style&index=0&id=0c1b1401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b1401",
  null
  
)

export default component.exports